import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { FormGroup } from "../../../components/FormGroup";
import { FormLabel } from "../../../components/FormLabel";
import { Input } from "../../../components/Input";
import { SelectInput } from "../../../components/SelectInput";
import { spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";
import colors from "@styling/colors";
import { BillingPeriod } from "@KassaroAB/shared/types/enums/BillingPeriod";

const StartDateHint = styled.span`
  font-size: ${fontSizes.small}px;
  color: ${colors.textMuted};
  display: block;
  margin-top: ${spacing.x05}px;
  margin-bottom: ${spacing.x1}px;
`;

interface PaymentTermsSectionProps {
  paymentTerms: BillingPeriod;
  onPaymentTermsChange: (terms: BillingPeriod) => void;
  startDate: string;
  onStartDateChange: (date: string) => void;
  minStartDate?: string;
}

const FieldsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.x2}px;

  @media (min-width: 769px) {
    flex-direction: row;
    align-items: flex-end;
    gap: ${spacing.x4}px;
  }
`;

const FieldGroup = styled(FormGroup)`
  flex: 1;
  min-width: 0;
`;

export const PaymentTermsSection = ({
  paymentTerms,
  onPaymentTermsChange,
  startDate,
  onStartDateChange,
  minStartDate,
}: PaymentTermsSectionProps) => {
  const { t } = useTranslation();
  return (
    <FormGroup>
      <FieldsRow>
        <FieldGroup>
          <FormLabel>{t("packageSelection.paymentTerms")}</FormLabel>
          <SelectInput
            value={paymentTerms}
            onChange={(e) => onPaymentTermsChange(e.target.value as BillingPeriod)}
          >
            <option value={BillingPeriod.MONTHLY}>{t("packageSelection.billingMonthly")}</option>
            <option value={BillingPeriod.QUARTERLY}>{t("packageSelection.billingQuarterly")}</option>
            <option value={BillingPeriod.YEARLY}>{t("packageSelection.billingYearly")}</option>
            <option value={BillingPeriod.TWO_YEARS}>{t("packageSelection.billingTwoYears")}</option>
            <option value={BillingPeriod.THREE_YEARS}>{t("packageSelection.billingThreeYears")}</option>
            <option value={BillingPeriod.FOUR_YEARS}>{t("packageSelection.billingFourYears")}</option>
            <option value={BillingPeriod.FIVE_YEARS}>{t("packageSelection.billingFiveYears")}</option>
          </SelectInput>
        </FieldGroup>
        <FieldGroup>
          <FormLabel>{t("packageSelection.startDate")}</FormLabel>
          <StartDateHint>{t("packageSelection.startDateHint")}</StartDateHint>
          <Input
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            min={minStartDate}
          />
        </FieldGroup>
      </FieldsRow>
    </FormGroup>
  );
};
